import React from 'react'
import PropTypes from 'prop-types';
import "./Financial.scss"

import SubLayout from '../../layouts/components/subLayout/SubLayout';

const Financial = (WrappedComponent) => {
  const ChildComponent = (props) => (

    <SubLayout>
      <WrappedComponent {...props} />
    </SubLayout>
  );

  return ChildComponent;
}


Financial.propTypes = {
  WrappedComponent: PropTypes.elementType.isRequired,
};

export default Financial